/**
 * Cart store — Task 31.2, 35.1
 * Zustand store for guest/authenticated cart state.
 * The cart data itself is fetched from the API; this store holds UI state
 * and the guest session token.
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Cart } from '@/types'

interface CartState {
  cart: Cart | null
  sessionToken: string | null
  isOpen: boolean
  setCart: (cart: Cart | null) => void
  setSessionToken: (token: string) => void
  openCart: () => void
  closeCart: () => void
  toggleCart: () => void
  clearCart: () => void
}

export const useCartStore = create<CartState>()(
  persist(
    (set) => ({
      cart: null,
      sessionToken: null,
      isOpen: false,

      setCart: (cart) => set({ cart }),

      setSessionToken: (token) => set({ sessionToken: token }),

      openCart: () => set({ isOpen: true }),
      closeCart: () => set({ isOpen: false }),
      toggleCart: () => set((s) => ({ isOpen: !s.isOpen })),

      clearCart: () => set({ cart: null }),
    }),
    {
      name: 'cart-storage',
      // Only persist the session token, not the full cart (re-fetched from API)
      partialize: (state) => ({ sessionToken: state.sessionToken }),
    },
  ),
)
